import { z } from 'zod'
import { corporateEmailSchema } from '../schemas/global.schemas'

export const signUpBodySchema = z.object({
  email: corporateEmailSchema,
  password: z.string()
})

export const signUpConfirmBodySchema = z.object({
  email: z.email(),
  code: z.string()
})

export const signUpConfirmResendBodySchema = z.object({
  email: z.email()
})

export const signInBodySchema = z.object({
  email: z.email(),
  password: z.string()
})

export const refreshTokenBodySchema = z.object({
  refreshToken: z.string()
})

export const forgotPasswordBodySchema = z.object({
  email: z.email()
})

export const forgotPasswordConfirmBodySchema = z.object({
  email: z.email(),
  code: z.string(),
  newPassword: z.string()
})

export const forgotPasswordConfirmFrontBodySchema = z.object({
  newPassword: z.string(),
  newPasswordConfirm: z.string()
})

export const changePasswordBodySchema = z.object({
  accessToken: z.string(),
  oldPassword: z.string(),
  newPassword: z.string()
})

export const signOutBodySchema = z.object({
  accessToken: z.string()
})

export type SignUpBody = z.infer<typeof signUpBodySchema>

export type SignUpConfirmBody = z.infer<typeof signUpConfirmBodySchema>

export type SignUpConfirmResendBody = z.infer<
  typeof signUpConfirmResendBodySchema
>

export type SignInBody = z.infer<typeof signInBodySchema>

export type ForgotPasswordBody = z.infer<typeof forgotPasswordBodySchema>

export type ForgotPasswordConfirmBody = z.infer<
  typeof forgotPasswordConfirmBodySchema
>

export type ChangePasswordBody = z.infer<typeof changePasswordBodySchema>
